import React from "react";

const LogoStripSection = () => {
  return (
    <section className="logo-strip-section" aria-label="Company logo strip">
      <div className="container">
        <p className="eyebrow">From Startups to Unicorns</p>
        <div className="logo-strip">
          <div
            className="company-logo-card"
            style={{ "--brand-color": "#111827" }}
          >
            <img alt="" loading="lazy" src="/company-logos/openai-mark.svg" />
            <span>OpenAI</span>
          </div>
          <div
            className="company-logo-card"
            style={{ "--brand-color": "#29b5e8" }}
          >
            <img
              alt=""
              loading="lazy"
              src="https://cdn.simpleicons.org/snowflake/29B5E8"
            />
            <span>Snowflake</span>
          </div>
          <div
            className="company-logo-card"
            style={{ "--brand-color": "#0052ff" }}
          >
            <img
              alt=""
              loading="lazy"
              src="https://cdn.simpleicons.org/coinbase/0052FF"
            />
            <span>Coinbase</span>
          </div>
          <div
            className="company-logo-card"
            style={{ "--brand-color": "#000000" }}
          >
            <img
              alt=""
              loading="lazy"
              src="https://cdn.simpleicons.org/notion/000000"
            />
            <span>Notion</span>
          </div>
          <div
            className="company-logo-card"
            style={{ "--brand-color": "#ff3008" }}
          >
            <img
              alt=""
              loading="lazy"
              src="https://cdn.simpleicons.org/doordash/FF3008"
            />
            <span>DoorDash</span>
          </div>
          <div
            className="company-logo-card"
            style={{ "--brand-color": "#635bff" }}
          >
            <img
              alt=""
              loading="lazy"
              src="https://cdn.simpleicons.org/stripe/635BFF"
            />
            <span>Stripe</span>
          </div>
          <div
            className="company-logo-card"
            style={{ "--brand-color": "#ff5a5f" }}
          >
            <img
              alt=""
              loading="lazy"
              src="https://cdn.simpleicons.org/airbnb/FF5A5F"
            />
            <span>Airbnb</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoStripSection;
